import { format } from 'date-fns';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import EditPencilIcon from '~/images/icons/EditPencil';
import { Colors } from '~/themes/colors';

interface IEditableDatePillProps {
  date: Date;
  onClick: () => void;
}

export const EditableDatePill = ({ date, onClick }: IEditableDatePillProps) => (
  <button
    type="button"
    data-testid="editable-date-pill"
    data-cy="editable-date-pill"
    onClick={onClick}
    style={{
      all: 'unset',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      padding: '8px 16px',
      borderRadius: 24,
      border: `1.5px solid ${colors.secondary[500]}`,
      backgroundColor: Colors.secondary_25,
      cursor: 'pointer',
    }}
  >
    <Typography as="span" size="body_large" color={colors.neutral[600]}>
      {format(date, 'EEE, MMM dd, yyyy')}
    </Typography>
    <EditPencilIcon size={16} color={colors.secondary[500]} />
  </button>
);
